var PsrHelpers = (function() {
    return {
        yyyymmddToDateFormat: function(date) {
            var year = date.substring(0, 4);
            var month = date.substring(4, 6);
            var day = date.substring(6, 8);

            return day + "/" + month + "/" + year;
        },

        yyyymmddToDate: function(date, time) {
            var year = date.substring(0, 4);
            var month = date.substring(4, 6);
            var day = date.substring(6, 8);
            var hour;
            var minute;

            if (time !== "X") {
                hour = time.substring(0, 2);
                minute = time.substring(2, 4);

                return new Date(year, month - 1, day, hour, minute);
            }

            return new Date(year, month - 1, day);
        },

        yyyymmddDateFormat: function(date, separetor) {
            var mm = date.getMonth() + 1;
            var dd = date.getDate();

            return [
                date.getFullYear(),
                (mm > 9 ? "" : "0") + mm,
                (dd > 9 ? "" : "0") + dd
            ].join(separetor || "");
        },

        hhmmTimeFormat: function(date, separetor) {
            var hh = date.getHours();
            var mm = date.getMinutes();

            return [
                (hh > 9 ? "" : "0") + hh,
                separetor || "",
                (mm > 9 ? "" : "0") + mm
            ].join("");
        },

        summertimeDateResolver: function(date, dateTime) {
            var year = date.substring(0, 4);
            var month = date.substring(4, 6);
            var day = date.substring(6, 8);
            var hour = "";
            var minute = "";
            var normaltimeDate = "";
            var summertimeDate = "";

            if (dateTime != "X") {
                hour = dateTime.substring(0, 2);
                minute = dateTime.substring(2, 4);
            }

            normaltimeDate = new Date(year, month - 1, day, hour, minute);
            summertimeDate = new Date(year, month - 1, day, hour, minute);
            summertimeDate.setHours(summertimeDate.getHours() - 1);

            return {
                normaltime: normaltimeDate,
                summertime: summertimeDate
            };
        },

        getParameterByName: function(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return "";
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        },

        isIOS: function() {
            var iDevices = [
                "iPad Simulator",
                "iPhone Simulator",
                "iPod Simulator",
                "iPad",
                "iPhone",
                "iPod"
            ];

            if (!!navigator.platform) {
                while (iDevices.length) {
                    if (navigator.platform === iDevices.pop()) {
                        return true;
                    }
                }
            }

            return false;
        }
    };
})();
